import React from "react"
import { Permission, Workspace, Connection } from "@/types"
import { useStore } from "@/store"
import { hasPermission } from "@/lib/utils"

type CommonProps = {
  permission: Permission
  workspace?: Workspace
  connection?: Connection
  hide?: boolean
}

type DisableableChild = React.ReactElement<{ disabled?: boolean }>

export type PermissionGuardProps =
  | (CommonProps & {
      disabled: true
      children: DisableableChild
    })
  | (CommonProps & {
      disabled?: false
      children: React.ReactElement
    })

const PermissionGuard = ({
  children,
  permission,
  workspace,
  connection,
  hide,
  disabled,
}: PermissionGuardProps) => {
  const [currentOrganization] = useStore((state) => [state.currentOrganization])

  if (!currentOrganization) return null

  const userPermissions = new Set([
    ...currentOrganization.myPermissions,
    ...(workspace?.myPermissions || new Set()),
    ...(connection?.myPermissions || new Set()),
  ])

  if (hasPermission(userPermissions, permission)) {
    return children
  }

  if (hide) return null

  if (disabled) {
    return React.cloneElement(children, {
      disabled: Boolean(children.props.disabled) || disabled,
    })
  }

  return null
}

export default PermissionGuard
